import { render, staticRenderFns } from "./TaskPerfGram.vue?vue&type=template&id=29e652aa&"
import script from "./TaskPerfGram.vue?vue&type=script&lang=js&"
export * from "./TaskPerfGram.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports